<template>
  <div id="home" ref="home">
    <!-- <article class="title my-4 pt-3 d-none d-md-block">
      <div class="mt-1 d-flex align-items-center">
        <img
          :src="require('@/assets/logo-text.svg')"
          alt="마술같은 일상, 마을예술창작소"
          @click="$router.push('/').catch(err => {})"
          class="logo-text "
        />
        <h1
          class="d-inline-block text-14 text-lg-28 ml-2 pl-1 text-grey-dark fw-700"
        >
          는 오늘 나의 삶을 표현하는 우리들의 마을예술을 창작하는 공간입니다.
        </h1>
        <div class="ml-4">
          <b-button
            variant="primary"
            class="mt-1"
            pill
            @click="$router.push('/introduce').catch(err => {})"
          >
            <span class="text-16 text-lg-16">소개 읽어보기</span>
            <i
              class="icon icon-sm-24 icon-28 icon-arr-right-white ml-1 mb-n2"
            ></i>
          </b-button>
        </div>
      </div>
    </article> -->
    <template v-if="slideList && slideList.length">
      <article class="w-100 pl-0">
        <carousel
          :perPage="1"
          class="carousel w-100 position-relative overflow-hidden"
          :paginationEnabled="false"
          :autoplay="true"
          :loop="true"
          :autoplayTimeout="4500"
          :autoplayHoverPause="false"
          :speed="1600"
          :minSwipeDistance="16"
        >
          <slide
            class="slide w-100 h-100 overflow-hidden"
            v-for="(slide, i) in slideList"
            :key="i"
            :style="`backgroundImage:url(${slide.src})`"
          >
            <!-- <div
            class="slide-info position-absolute bottom-0 ml-4 ml-md-5 mb-3 w-50 text-white zIndex-11"
          >
            <h2 class="my-2 text-16 text-lg-36 text-truncate">
              {{ slide.title }}
            </h2>
            <p class="text-14 text-lg-16 text-truncate">{{ slide.summary }}</p>
          </div>
          <div class="dim w-100 h-100 position-absolute"></div> -->
          </slide>
        </carousel>
      </article>
    </template>
    <template v-else>
      <div class="w-100 position-relative" :style="{ paddingBottom: '40%' }">
        <section class="loading text-center position-absolute-center">
          <i class="my-3 mx-2 icon icon-loading icon-56"></i>
          <i class="my-3 mx-2 icon icon-loading icon-56"></i>
          <i class="my-3 mx-2 icon icon-loading icon-56"></i>
        </section>
      </div>
    </template>

    <article class="container-fluid">
      <b-row>
        <b-col cols="12" lg="9">
          <section class="section-webzine pb-5">
            <div class="section-info  pl-0 pt-4 pb-2 px-md-5 bg-secondary">
              <h3 class="text-24 text-lg-28 fw-700 pl-4 pl-md-0">
                웹진 '담다'
              </h3>
              <p class="mt-3 text-14 text-lg-16 pl-4 pl-md-0">
                서울 시민, 골목의 삶이 담긴 예술을 담습니다.
              </p>
            </div>
            <webzine-list
              :list="newWebzine"
              class="webzine-news"
            ></webzine-list>
          </section>
          <!-- <section class="section-movie">
            <div class="bg-purple text-white">
              <div class="section-info p-4">
                <h3 class="text-lg-24 fw-700">마술소 Movie</h3>
                <p class="mt-3 text-lg-16">
                  Movie에 대한 설명입니다
                </p>
              </div>
              <div class="p-4">
                <youtube video-id="bHU3WrR7xuk"
                player-width="100%" player-height="720"></youtube>
              </div>
            </div>
          </section> -->
        </b-col>
        <!-- <b-col md="1" class="d-none d-md-block"></b-col> -->
        <b-col cols="12" lg="3" class="ml-auto ml-md-0 pl-0 pl-md-4">
          <section class="section-webzine bg-third pb-5">
            <div
              class="section-info p-4 px-md-4 pt-md-5 pb-md-2 text-grey-dark"
            >
              <h3 class="text-21 text-lg-21 fw-700">
                내 주변의 마을예술창작소는?
              </h3>
              <p class="mt-2 text-14 text-lg-16">
                지역별 마을예술창작소 위치를 찾아봅시다
              </p>
            </div>
            <div class="text-left text-lg-right">
              <b-button
                variant="third"
                class="ml-3 ml-md-5 ml-lg-auto mr-4"
                pill
                @click="$router.push('/contact').catch((err) => {})"
              >
                <span class="text-16 text-lg-16">마술소 찾기</span>
                <i
                  class="icon icon-sm-24 icon-28 icon-arr-right ml-1 mb-n2"
                ></i>
              </b-button>
            </div>
          </section>
          <section class="mt-3 px-3 px-md-0">
            <div class="bg-primary p-4">
              <h3 class="text-lg-24 fw-700 mb-3 text-white">마술소 자료실</h3>
            </div>
            <template v-if="allDataRoom && allDataRoom.length">
              <ul class="list-unstyled">
                <li
                  class="py-2 border-bottom"
                  v-for="(item, i) in allDataRoom"
                  :key="i"
                >
                  <b-row>
                    <b-col cols="9" class="overlfow-hidden d-flex">
                      <b-btn
                        variant="text"
                        class="text-primary p-0 text-truncate"
                        @click="$router.push('dataroom/' + item._id)"
                      >
                        <span class="text-14 text-lg-14">
                          {{ item.title }}
                        </span>
                      </b-btn>
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="text-12 text-lg-12 text-nowrap">
                        {{ item.createdAt }}
                      </span>
                    </b-col>
                  </b-row>
                </li>
              </ul>
            </template>

            <template v-else>
              <section class="loading text-center">
                <i class="my-3 mx-2 icon icon-loading icon-56"></i>
                <i class="my-3 mx-2 icon icon-loading icon-56"></i>
                <i class="my-3 mx-2 icon icon-loading icon-56"></i>
              </section>
            </template>
          </section>
        </b-col>
      </b-row>
    </article>
  </div>
</template>

<script>
import WebzineList from "@/components/WebzineList";

export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소",
    };
  },
  components: {
    WebzineList,
  },
  data() {
    return {
      slideList: [],
      newWebzine: [],
      allDataRoom: [],
    };
  },
  computed: {
    // allData() {
    //   return this.$store.getters.allData;
    // },
    // newWebzines() {
    //   let arr = this.allData.allWebzine;
    //   return arr
    //     .sort(function(a, b) {
    //       return a.createdAt - b.createdAt;
    //     })
    //     .splice(0, 6);
    // }
  },
  methods: {
    loadAllWebzine() {
      this.$db
        .collection("allWebzine")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.newWebzine = arr
            .sort(function(a, b) {
              return new Date(b.createdAt) - new Date(a.createdAt);
            })
            .splice(0, 6);
        });
    },
    loadAllIntroImages() {
      this.$db
        .collection("introImages")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.slideList = arr;
        });
    },
    loadAllDataroom() {
      this.$db
        .collection("allDataRoom")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allDataRoom = arr
            .sort(function(a, b) {
              return new Date(b.createdAt) - new Date(a.createdAt);
            })
            .splice(0, 6);
        });
    },
  },
  async mounted() {
    await this.loadAllWebzine();
    await this.loadAllIntroImages();
    await this.loadAllDataroom();
  },
};
</script>

<style lang="scss" scoped>
.logo-text {
  width: 7.4rem !important;
  cursor: pointer;
}
.carousel {
  user-select: none !important;
  // height: 60rem !important;
  .slide {
    user-select: none !important;
    // height: 60rem !important;
    padding-bottom: 40%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
}
.dim {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 40%
  );
}

@media all and (max-width: 768px) {
  .carousel {
    height: 30rem !important;
    .slide {
      height: 30rem !important;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
</style>
